import "./../sass/index.scss";
import "lightgallery/dist/css/lightgallery.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "nunjucks/browser/nunjucks-slim";
import "lightgallery";
import "./outlets/index"
import "./components/contact.js";
import "./components/header.js";
window.Pagination = require("@jemmyphan/js-pagination");
window.Url = require("domurl");
window.Swal = require("sweetalert");

const loadmap = (element, lat, lng) => {
  if (!element || !lat || !lng) {
    return;
  }
  const mapElement = document.getElementById(element);
  const importScript = document.createElement("script");

  mapElement.style["height"] = "300px";
  mapElement.style["width"] = "100%";

  importScript.src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyCREzTBUqn86NbH00DGJgIqgZCVF8gc-3k&callback=initMap";
  importScript.async = true;
  importScript.defer = true;

  const loadScript = document.createElement("script");
  loadScript.text = `
    function initMap()  {
      var latlang = { lat: ${lat}, lng: ${lng} };
      var map = new google.maps.Map(document.getElementById('${element}'), {
        zoom: 16,
        center: latlang,
      });
      var marker = new google.maps.Marker({
        position: latlang,
        map: map
      });
    }
  `;
  mapElement.parentNode.insertBefore(importScript, mapElement.nextSibling);
  mapElement.parentNode.insertBefore(loadScript, mapElement.nextSibling);
};

window.$ = $;
window.loadmap = loadmap;



// WEBPACK FOOTER //
// ./assets/js/styles.js